import NotFound from './NotFound'
import localize from '../../higherOrderComponents/localize'

export default localize(NotFound)



// WEBPACK FOOTER //
// ./src/routes/NotFound/index.js